import { 
	AppAction, 
	Namespace as AppActionNS 
} from '../app.actions';
import { 
	FolderAction,
	Namespace as FolderActionNS 
} from 'sharebase-app/components/folderView/folderView.actions';
import {
	SharedContentAction,
	Namespace as SharedContentNS
} from 'sharebase-app/components/sharedContent/sharedContent.actions';
import {
	TrashAction,
	Namespace as TrashActionNS
} from 'sharebase-app/components/deletedItems/deletedItems.actions';
import {
	NotificationAction,
	Namespace as NotificationActionNS
} from 'sharebase-app/components/notifications/notifications.actions';
import {
	DocumentAction,
	Namespace as DocumentActionNS
} from 'sharebase-app/components/documentView/documentView.actions';
import { 
	TaskAction,
	Namespace as TaskActionNS	
} from 'sharebase/domain/task.actions';
import { ActionRepository } from 'sharebase/services/actionRepository';
import {
	ItemType, 
	PermissionType 
} from 'phoenix/domain';

export default function registerActions(
	sbActionRepository:ActionRepository,
	gettextCatalog:ng.gettext.gettextCatalog
) {
	sbActionRepository
		.register([{
			action: AppAction.EditInShareBaseDesktop,
			label: gettextCatalog.getString('Edit in ShareBase Desktop'), 
			icon: 'logo:icon',
			permissions: PermissionType.MODIFY,
			allowedTypes: ItemType.Document			
		}, {
			action: AppAction.EditInOfficeOnline,
			label: gettextCatalog.getString('Edit in Office Online'),
			icon: 'logo:msOffice',
			allowedTypes: ItemType.Document,
			permissions: PermissionType.MODIFY
		}, {
			// To move a folder, the following conditions must be met; some of which can't be checked here.
			// 1. User must have permissions to create folders in the parent (can't be checked here)
			// 2. User must have full control access to item being moved

			// To move a document, the following conditions must be met; some of which can't be checked here.
			// 1. User must have permissions to create documents in the parent
			// 2. User must have full control access to document
			action: AppAction.Move,
			label:  gettextCatalog.getString('Move'), 
			icon: 'open_with', 
			permissions: PermissionType.FULLCONTROL,
			allowedTypes: ItemType.Document | ItemType.Folder,
			multiItem: true
		}, {
			action: AppAction.Copy, 
			label: gettextCatalog.getString('Copy'), 
			icon: 'content_copy',
			permissions: PermissionType.DOWNLOAD | PermissionType.DNLDDOC,
			allowedTypes: ItemType.Document,
			multiItem: true,
			denyLinkUser: true
		}, {
			action: AppAction.CreateTask, 
			label: gettextCatalog.getString('Create a Task'), 
			icon: 'assignment_turned_in',
			permissions: PermissionType.MODIFY,
			allowedTypes: ItemType.Document,
			denyLinkUser: true
		}, {
			action: AppAction.Delete, 
			label: gettextCatalog.getString('Delete'), 
			icon: 'delete', 
			permissions: PermissionType.DELETE,
			allowedTypes: ItemType.Document | ItemType.Folder,
			multiItem: true
		}, {
			action: AppAction.Download, 
			label: gettextCatalog.getString('Download'), 
			icon: 'file_download',
			permissions: PermissionType.DOWNLOAD | PermissionType.DNLDDOC | PermissionType.DNLDFOLD,
			allowedTypes: ItemType.All,
			multiItem: true
		}, {
			action: AppAction.Rename, 
			label: gettextCatalog.getString('Rename'), 
			icon: 'text_format', 
			permissions: PermissionType.MODIFY,
			allowedTypes: ItemType.Document | ItemType.Folder
		}, {
			action: AppAction.Replace, 
			label: gettextCatalog.getString('Replace'), 
			icon: 'file_upload',
			permissions: PermissionType.MODIFY,
			allowedTypes: ItemType.Document
		}, {
			action: AppAction.CreateDocumentLinkShare, 
			label: gettextCatalog.getString('Create Link'), 
			icon: 'link', 
			permissions: PermissionType.SHLINK | PermissionType.SHLKDOC,
			allowedTypes: ItemType.Document
		}, {
			action: AppAction.CreateDocumentUserShare, 
			label: gettextCatalog.getString('Share With Users'), 
			icon: 'group_add', 
			permissions: PermissionType.SHARE | PermissionType.SHDOC,
			allowedTypes: ItemType.Document
		}, {
			action: AppAction.CreateFolderLinkShare, 
			label: gettextCatalog.getString('Create Link'), 
			icon: 'link', 
			permissions: PermissionType.SHLINK | PermissionType.SHLKFOLD,
			allowedTypes: ItemType.Folder
		}, {
			action: AppAction.CreateFolderUserShare, 
			label: gettextCatalog.getString('Share With Users'), 
			icon: 'group_add', 
			permissions: PermissionType.SHARE | PermissionType.SHFOLD,
			allowedTypes: ItemType.Folder
		}, {
			action: AppAction.OpenInNew,
			label: gettextCatalog.getString('Open In New Window'),
			icon: 'launch',
			allowedTypes: ItemType.Document | ItemType.Folder
		}, {
			action: AppAction.Favorite,
			label: gettextCatalog.getString('Add Favorite'),
			icon: 'star',
			allowedTypes: ItemType.Document | ItemType.Folder,
			multiItem: true,
			denyLinkUser: true
		}, {
			action: AppAction.Unfavorite,
			label: gettextCatalog.getString('Remove Favorite'),
			icon: 'star_border',
			allowedTypes: ItemType.Document | ItemType.Folder,
			multiItem: true,
			denyLinkUser: true
		}], AppActionNS);

		sbActionRepository
			.register([{
				action: FolderAction.SelectAll, 
				label: gettextCatalog.getString('Select all'), 
				icon: 'select_all',
				multiItem: true,
			}, {
				action: FolderAction.Scan,
				label: gettextCatalog.getString('Scan'), 
				icon: 'scanner',
				permissions: PermissionType.ADDDOC,
				allowedTypes: ItemType.Folder
			}, {
				action: FolderAction.OpenFolder, 
				label: gettextCatalog.getString('Open'), 
				icon: 'folder',
				permissions: PermissionType.READFOLD,
				allowedTypes: ItemType.Folder
			}, {
				action: FolderAction.OpenDocument, 
				label: gettextCatalog.getString('Open'), 
				icon: 'insert_drive_file', 
				permissions: PermissionType.READ,
				allowedTypes: ItemType.Document
			},{
				action: FolderAction.CreateFolder, 
				label: gettextCatalog.getString('Create Folder'), 
				icon: 'create_new_folder',
				permissions: PermissionType.ADDFOLD,
				allowedTypes: ItemType.Folder | ItemType.Library
			}, {
				action: FolderAction.UploadDocument,
				label: gettextCatalog.getString('Upload'),
				icon: 'file_upload',
				permissions: PermissionType.ADDDOC,
				allowedTypes: ItemType.Folder
			}, {
				action: FolderAction.CreateDocument,
				label: gettextCatalog.getString('Create Document'),
				icon: 'note_add',
				permissions: PermissionType.ADDDOC,
				allowedTypes: ItemType.Folder
			}], FolderActionNS);
			
		sbActionRepository
			.register([{
				action: DocumentAction.Save,
				label: gettextCatalog.getString('Save'),
				icon: 'check_circle',
				permissions: PermissionType.MODIFY,
				allowedTypes: ItemType.Document
			}], DocumentActionNS);
	
		sbActionRepository
			.register([{
				action: SharedContentAction.CollapseShares,
				label: gettextCatalog.getString('Collapse Shares'),
				icon: 'layers'
			}, {
				action: SharedContentAction.ExpandShares,
				label: gettextCatalog.getString('Expand Shares'),
				icon:  'layers_clear'
			},{
				action: SharedContentAction.OpenLibrary, 
				label: gettextCatalog.getString('Open'), 
				icon: 'account_balance', 
				permissions: PermissionType.READ,
				allowedTypes: ItemType.Library
			}], SharedContentNS);
	
		sbActionRepository.register([{
			action: TrashAction.Purge,
			label: gettextCatalog.getString('Purge'),
			icon: 'delete_forever',
			permissions: PermissionType.DELETE
		},{
			action: TrashAction.PurgeSelected,
			label: gettextCatalog.getString('Purge Selected'),
			icon: 'delete_forever',
			multiItem:true,	
			permissions: PermissionType.DELETE
		}, {
			action: TrashAction.PurgeAll,
			label: gettextCatalog.getString('Purge All'),
			icon: 'delete_forever',	
			multiItem: true,
			permissions: PermissionType.DELETE
		}, {
			action: TrashAction.Restore,
			label: gettextCatalog.getString('Restore'),
			icon: 'settings_backup_restore',
			permissions: PermissionType.DELETE
		}, {
			action: TrashAction.RestoreSelected,
			label: gettextCatalog.getString('Restore Selected'),
			icon: 'settings_backup_restore',
			multiItem:true,	
			permissions: PermissionType.DELETE		
		}, {
			action: TrashAction.RestoreAll,
			label: gettextCatalog.getString('Restore All'),
			icon: 'settings_backup_restore',
			multiItem: true,
			permissions: PermissionType.DELETE
		}], TrashActionNS);
	
		sbActionRepository.register([{
			action: NotificationAction.ClearAll, 
			label: gettextCatalog.getString('Clear all notifications'), 
			icon: 'clear_all',
			denyLinkUser: true,
			multiItem: true
		}], NotificationActionNS);

		sbActionRepository.register([{
			action: TaskAction.QuickApprove1,
			label: gettextCatalog.getString('Approved'),
			icon: 'check'
		}, {
			action: TaskAction.QuickApprove2,
			label: gettextCatalog.getString('Looks good to me!'),
			icon: 'check'
		}, {
			action: TaskAction.ApproveWithComment,
			label: gettextCatalog.getString('Custom comment'),
			icon: 'comment'
		}, {
			action: TaskAction.QuickDeny1,
			label: gettextCatalog.getString('Denied'),
			icon: 'close'
		}, {
			action: TaskAction.QuickDeny2,
			label: gettextCatalog.getString('Not mine to approve'),
			icon: 'close'
		}, {
			action: TaskAction.DenyWithComment,
			label: gettextCatalog.getString('Custom comment'),
			icon: 'comment'
		}, {
			action: TaskAction.Cancel,
			label: gettextCatalog.getString('Cancel'),
			icon: 'close'
		}], TaskActionNS)
}

registerActions.$inject = [
	'sbActionRepository',
	'gettextCatalog'
];


// WEBPACK FOOTER //
// ./src/sharebase-app/components/_app/helpers/registerActions.ts